import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Col, Form, Input, Modal, Row, Select, Space } from "antd";
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { ApplicationType } from "../../app/applicationSlice";
import { RootDispatch } from "../../app/store";
import { EditableList } from "../../compnents/list/EditableList";
import { NavBar } from "../../compnents/nav/NavBar";
import { traceRoute } from "../../layouts/layoutSlice";
import { Department } from "../../models/department";
import { User } from "../../models/user";
import { GetUserListParams } from "../../services/user";
import { ThemeContext } from "../../theme/ThemeContext";
import { getFullDeparmentList, getUserAdd } from "../completion/completionSlice";
import { GrantMenus } from "../grant/Grant";
import { directLogin } from "../login/loglinSlice";
import { columns } from "./columns";
import { UserModal } from "./UserModal";
import {
  getUserList,
  resetUserPassword,
  selectUserPage,
  toggleUserState,
} from "./userSlice";

export interface UsersRef {
  refresh: () => void;
}

const RealUsers = (_: unknown, ref: React.Ref<UsersRef>): ReactElement => {
  const dispatch = useDispatch<RootDispatch>();

  const theme = useContext(ThemeContext);

  const [form] = Form.useForm();

  const page = useSelector(selectUserPage);

  const [userId, setUserId] = useState("");

  const [userName, setUserName] = useState<any>("");

  const { tenantId } = useParams<{ tenantId?: string }>();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [editingPermissionUserId, setEditingPermisionUserId] = useState("");

  const [params, setParams] = useState<GetUserListParams>({
    current: 1,
    state: 1,
  });

  const [departments, setDepartments] = useState<Department[]>([]);

  useEffect(() => {
    dispatch(getUserList({ ...params, tenantId }));
  }, [dispatch, params, tenantId]);

  useEffect(() => {
    dispatch(getFullDeparmentList({ current: 1, tenantId }))
      .then(unwrapResult)
      .then((departments) => setDepartments(departments));
  }, [tenantId]);


  useEffect(() => {
    if (!userName) return
    const tempArr = page.items.filter((v: any) => v.name == userName)
    dispatch(getUserAdd({ id: tempArr?.[0]?.id, tenantId: tempArr?.[0]?.tenantId }))
      .then(unwrapResult)
      .then(() => setUserName(''));
  }, [page]);

  useImperativeHandle(ref, () => ({
    refresh: () => dispatch(getUserList({ ...params, tenantId })),
  }));

  return (
    <Col
      style={{
        height: tenantId ? "calc(100% - 20px)" : "calc(100% - 30px)",
        overflow: "hidden",
        position: "relative",
        marginTop: 10,
        marginBottom: 10,
        marginLeft: tenantId ? 30 : 0,
        marginRight: tenantId ? 30 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {tenantId ? (
        <NavBar
          where={["机构管理", "员工管理"]}
          backtrace={{
            name: "机构管理",
            path: "/admin/tenant",
          }}
          style={{ marginBottom: 10 }}
          buttons={[
            <Button
              key="0"
              icon={<PlusOutlined />}
              type="primary"
              onClick={() => setIsModalVisible(true)}
              size="small"
            >
              新增
            </Button>,
          ]}
        />
      ) : (
        <Button
          icon={<PlusOutlined />}
          type="primary"
          onClick={() => setIsModalVisible(true)}
          size="small"
          style={{
            position: "fixed",
            top: 78,
            right: 45,
          }}
        >
          新增
        </Button>
      )}
      <Col
        style={{
          flex: 1,
          backgroundColor: theme.pn,
          borderRadius: 10,
          padding: "10px 15px 0 15px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Form
          form={form}
          autoComplete="off"
          onFinish={(values) => {
            setParams({ ...params, ...values, current: 1 });
          }}
        >
          <Row
            align="middle"
            justify="space-between"
            style={{ marginTop: 10, marginBottom: 20 }}
          >
            <Space>
              <Form.Item name="param" noStyle>
                <Input
                  placeholder="请输入姓名/手机号"
                  style={{ width: 230 }}
                  prefix={<SearchOutlined color={theme.tc3} />}
                  allowClear
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name="outpatientDepartmentId" noStyle>
                <Select
                  placeholder="行政科室 - 全部"
                  onChange={form.submit}
                  allowClear
                  style={{ width: 160 }}
                >
                  {departments.map((d) => (
                    <Select.Option key={d.id} value={d.id}>
                      {d.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="role" noStyle>
                <Select
                  placeholder="是否管理员 - 全部"
                  onChange={form.submit}
                  allowClear
                  style={{ width: 160 }}
                >
                  <Select.Option value={1}>是</Select.Option>
                  <Select.Option value={0}>否</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name="state" noStyle initialValue={1}>
                <Select
                  placeholder="注销状态 - 全部"
                  onChange={form.submit}
                  allowClear
                  style={{ width: 160 }}
                >
                  <Select.Option value={0}>已注销</Select.Option>
                  <Select.Option value={1}>未注销</Select.Option>
                </Select>
              </Form.Item>
            </Space>
            <Button type="primary" onClick={form.submit}>
              查询
            </Button>
          </Row>
        </Form>
        <EditableList<User>
          page={page}
          columns={columns(
            (action, user) => {
              switch (action) {
                case "menus":
                  if (tenantId) {
                    dispatch(
                      traceRoute({
                        path: `/admin/tenant/${tenantId}/user/${user.id}/menu`,
                        name: `${user.name}-权限管理`,
                        query: `type=${0}`,
                      })
                    )
                  } else {
                    setEditingPermisionUserId(user.id);
                  }
                  break;
                case "toggle":
                  dispatch(toggleUserState({ userId: user.id, tenantId })).then(
                    () => {
                      // dispatch(getUserList(params));
                      setParams({ ...params })
                    }
                  );
                  break;
                case "reset":
                  Modal.confirm({
                    title: "是否重置密码？",
                    content: `重置密码为员工手机号码后四位`,
                    cancelText: "取消",
                    okText: "确认",
                    onOk: () =>
                      dispatch(
                        resetUserPassword({
                          id: user.id,
                          phone: user.phone,
                          tenantId,
                        })
                      ),
                  });
                  break;
                case "login":
                  if (tenantId) {
                    dispatch(directLogin({ tenantId, phone: user.phone }))
                      .then(unwrapResult)
                      .then(() => {
                        // win = window.open("http://localhost:3001/", "_blank");
                        // win?.focus();
                      })
                      .catch(() => {
                        // do nothing.
                      });
                  }
                  break;
                case "setting":
                  dispatch(
                    traceRoute({
                      name: "个人设置",
                      path: "/personalSetting",
                      query: `state=${user.id}`,
                    })
                  )
                  break;
              }
             

            },
            page.size * (page.current - 1),
            tenantId
          )}
          onChangePage={(current, size) =>
            setParams({ ...params, current, size })
          }
          onRow={(u) => ({
            onDoubleClick: () => {
              setUserId(u.id);
              setIsModalVisible(true);
            },
          })}
        />
      </Col>
      <UserModal
        visible={isModalVisible}
        userId={userId}
        tenantId={tenantId}
        onCancel={() => {
          setUserId("");
          setIsModalVisible(false);
        }}
        onOk={(name) => {

          setUserId("");
          setUserName(name);
          setIsModalVisible(false);
          // dispatch(getUserList(params));
          setParams({ ...params })
        }}

      />
      <Modal
        width={960}
        title="菜单权限"
        visible={!!editingPermissionUserId}
        onCancel={() => setEditingPermisionUserId("")}
        footer={null}
      >
        <GrantMenus
          type={ApplicationType.Application}
          userId={editingPermissionUserId}
        />
      </Modal>
    </Col>
  );
};

export const Users = forwardRef(RealUsers);
